export var rowTypeAttr = 'k-parent-node';
export var colgroupAttr = 'k-colgroup-data';
